import { useTheme, useMediaQuery as useMediaQuerySource, type Breakpoint, type Breakpoints } from '@mui/material';

const useMediaQuery = (breakpoint: Breakpoint, direction?: 'down' | 'up'): boolean => {
  const theme = useTheme();
  const isDeviceSpecifiedBreakpointDown = useMediaQuerySource(
    // @ts-lint: ignore
    theme.breakpoints[direction ?? 'down'](breakpoint ?? 'lg')
  );

  return isDeviceSpecifiedBreakpointDown;
};

export default useMediaQuery;
